// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === "spa-assets/on-demand/global-global-social-module-styles") return "spa-assets/on-demand/global-global-social-module-styles-cd3cc7ca6be2e5a8e135.css";
	// return url for filenames based on template
	return undefined;
};